// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"ad5ba549","488":"ad358a3c","579":"238a45d3","612":"ba6a1304","998":"85a0cc53"}[chunkId] + ".chunk.js";
};